// extracted by mini-css-extract-plugin
export default {"empty":"XBM2a"};